import script from "./TransitionExpanded.vue?vue&type=script&setup=true&lang=ts"
export * from "./TransitionExpanded.vue?vue&type=script&setup=true&lang=ts"

import "./TransitionExpanded.vue?vue&type=style&index=0&id=2a34a85c&lang=scss"

const __exports__ = script;

export default __exports__